/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CompleteRequestBuilderRequestsMetadata, type CompleteRequestBuilder } from './complete/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/upload
 */
export interface UploadRequestBuilder extends BaseRequestBuilder<UploadRequestBuilder> {
    /**
     * The complete property
     */
    get complete(): CompleteRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const UploadRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/upload";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const UploadRequestBuilderNavigationMetadata: Record<Exclude<keyof UploadRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    complete: {
        requestsMetadata: CompleteRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
